import {fork, put} from 'redux-saga/effects';
import {watch, runWhile} from 'store/effects';
import {userIsOnline} from 'store/google-calendar';
import {calendars} from './calendars';
import {channel} from './channel';
import {read} from './read';
import {update, updateSettings} from './update';
import {resync, session} from './watchers';

export function* googleCalendarSagaManager() {
  yield watch(userIsOnline, function* (value) {
    yield runWhile(googleCalendarSaga, value);
  });
  yield watch(state => state.settings.googleSyncEnabled, function* (now, prev, action) {
    if (prev !== undefined && now && !prev && action.type == 'SERVER_DATA_RECEIVED') {
      yield put({
        type: 'UI_DISPLAY_MODAL',
        id: 'CalendarSyncPopup'
      });
    }
  });
}

function* googleCalendarSaga() {
  yield fork(calendars);
  yield fork(channel);
  yield fork(read);
  yield fork(resync);
  yield fork(session);
  yield fork(update);
  yield fork(updateSettings);
}
